import { Icons } from "../../constants/icon-library";

export const SectionCard = ({ title, action, children }) => (
  <div className="card border mb-4">
    <div className="card-header bg-body d-flex justify-content-between align-items-center">
      <span className="fw-bold">{title}</span>
      {action || null}
    </div>
    <div className="card-body">{children}</div>
  </div>
);

export const KeyValueEditor = ({
  items,
  onAdd,
  onChange,
  onRemove,
  keyPlaceholder,
  valuePlaceholder,
  addLabel,
}) => (
  <>
    {Array.isArray(items) &&
      items.map((item) => (
        <div key={item?.id} className="d-flex gap-2 mb-2">
          <input
            className="form-control form-control-sm"
            placeholder={keyPlaceholder}
            value={item?.key || ""}
            onChange={(event) => onChange(item?.id, "key", event.target.value)}
          />
          <input
            className="form-control form-control-sm"
            placeholder={valuePlaceholder}
            value={item?.value || ""}
            onChange={(event) =>
              onChange(item?.id, "value", event.target.value)
            }
          />
          <button
            className="btn btn-sm btn-outline-danger"
            type="button"
            onClick={() => onRemove(item?.id)}
          >
            <i className={`wb ${Icons("delete")}`}></i>
          </button>
        </div>
      ))}
    <button
      className="btn btn-sm btn-outline-secondary"
      type="button"
      onClick={onAdd}
    >
      {addLabel}
    </button>
  </>
);
